var map = {
	"./arsflag.svg": 895,
	"./aznflag.svg": 1738,
	"./bdtflag.svg": 9509,
	"./bifflag.svg": 1451,
	"./brlflag.svg": 3087,
	"./clpflag.svg": 4784,
	"./cnyflag.svg": 9315,
	"./copflag.svg": 2261,
	"./crcflag.svg": 9393,
	"./egpflag.svg": 6011,
	"./euroflag.svg": 8582,
	"./gbpflag.svg": 4346,
	"./ghcflag.svg": 7935,
	"./gtqflag.svg": 8309,
	"./idrflag.svg": 9448,
	"./inrflag.svg": 9930,
	"./jpyflag.svg": 9287,
	"./kesflag.svg": 1172,
	"./kgsflag.svg": 3586,
	"./krwflag.svg": 3613,
	"./kztflag.svg": 1122,
	"./lakflag.svg": 5499,
	"./mdlflag.svg": 3926,
	"./mxnflag.svg": 2612,
	"./myrflag.svg": 4279,
	"./ngnflag.svg": 7005,
	"./orangeDollar.svg": 223,
	"./penflag.svg": 1694,
	"./phpflag.svg": 1659,
	"./pkrflag.svg": 1604,
	"./plnflag.svg": 4741,
	"./rubflag.svg": 4920,
	"./rupeeorange.svg": 3048,
	"./rwfflag.svg": 8670,
	"./sgdflag.svg": 937,
	"./thbflag.svg": 2593,
	"./tryflag.svg": 9744,
	"./tzshsflag.svg": 1905,
	"./uaeflag.svg": 9756,
	"./uahflag.svg": 4825,
	"./ugxflag.svg": 1187,
	"./usdflag.svg": 1907,
	"./uzsflag.svg": 3843,
	"./vndflag.svg": 5399,
	"./xafflag.svg": 1650,
	"./xofflag.svg": 8404,
	"./zarflag.svg": 7692,
	"./zmwflag.svg": 981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2325;